import '@sass/common/theme.scss';
import CwLoadModules from '@customjs/module-loader.js';
import CwThemeFramework from '@customjs/generalFns.js';
import { MatchHeight } from 'js-match-height';

/**
 * Running mixed functions across the theme
 */
CwThemeFramework.generalFns();

/**
 * Bootstrap Tabs
 */
const tabs = document.querySelector('[role="tablist"]');

if (tabs) CwLoadModules.Tabs();

/**
 * Dropdown
 */
const dropdown = document.querySelector('.dropdown-toggle');

if (dropdown) CwLoadModules.Dropdown();

/**
 * Accordions
 */
const accordion = document.querySelector('.accordion');

if (accordion) CwLoadModules.Collapse();

/**
 * Service Worker
 */

// check if service worker is available

if ('serviceWorkerNO' in navigator) {
    document.addEventListener('DOMContentLoaded', () => {
        // Registering Service Worker
        navigator.serviceWorker
            // eslint-disable-next-line no-undef
            .register(`${ThemeURLS.childThemeURL}/sw.php`, {
                scope: '/',
            })
            .then((reg) => console.log(reg.scope))
            .catch((error) => console.log(error.message));
    });
}

/**
 * Loading Mobile Menu
 */

function matchMobile() {
    const mobileMediaQuery = window.matchMedia('(max-width: 768px)');
    return mobileMediaQuery.matches;
}

matchMobile() ? CwThemeFramework.mobileMenu() : '';

window.addEventListener('resize', () => {
    matchMobile() ? CwThemeFramework.mobileMenu() : '';
});

/**
 * Loading Modals in the Page
 * We will be pulling all the buttons with the data-cw-target
 * Attribute in order to initialize all the modals.
 */

// Checking for all out buttons
const modals = document.querySelectorAll('[data-cw-target]');
if (modals.length) {
    const modalInstances = [];
    CwLoadModules.modals().then((CwModals) => {
        modals.forEach((modalBtn, index) => {
            modalInstances[index] = new CwModals('.cw-modal');
            modalInstances[index].init();
        });
    });
}

/**
 * Loading Swiper JS
 * https://swiperjs.com/
 */
const carouselModules = {
    'results-slider': 'results-carousel',
    'results-slider__sidebar': 'results-slider-sidebar',
    'awards-wrap': 'awards-carousel',
    'awards-wrap-sidebar': 'awards-carousel-sidebar',
    'testimonials-section-slider': 'testimonials-carousel',
    'testimonials-section-slider-sidebar': 'testimonials-carousel-sidebar',
    'grid-attorney': 'team-carousel',
    'grid-videos': 'videos-carousel',
    'hero-videos-carousel': 'hero-videos-carousel',
    'fourth-section__videos': 'fourth-section-carousel',
    'our-team': 'team-sidebar-widget',
    'podcast-episodes-swiper': 'podcast-episodes-carousel',
    'podcast-shows-swiper': 'podcast-section-carousel',
    'podcast-sidebar-swiper': 'podcast-sidebar-carousel',
    'ebook-swiper': 'ebook-carousel',
    'ebook-about-swiper': 'ebook-about',
    'fifth-section-videos': 'fifth-section-videos-carousel',
    'podcast-watch-slider': 'podcast-recent-episodes-carousel',
    'podcast-playlists-slider': 'podcast-playlist-carousel',
    'stories-video-carousel': 'stories-video-carousel',
};

// eslint-disable-next-line no-restricted-syntax
for (const [key, value] of Object.entries(carouselModules)) {
    const name = document.getElementById(key);
    if (name) {
        CwLoadModules.swiperSliders(value)
            .then((module) => {
                module.default();
            })
            .catch((error) => {
                // A ChunkLoadError happens when a lazy-loaded bundle referenced by
                // the cached main bundle is stale/missing (e.g. after a rebuild or
                // deploy). Reload once to fetch the fresh chunk manifest instead of
                // leaving an uncaught promise rejection that halts other carousels.
                const isChunkError =
                    error &&
                    (error.name === 'ChunkLoadError' ||
                        /Loading chunk .* failed/i.test(error.message || ''));

                if (isChunkError && !sessionStorage.getItem('chunkReloaded')) {
                    sessionStorage.setItem('chunkReloaded', '1');
                    window.location.reload();
                    return;
                }

                // eslint-disable-next-line no-console
                console.warn(`Failed to load carousel module "${value}":`, error);
            });
    }
}

window.addEventListener('load', () => {
    sessionStorage.removeItem('chunkReloaded');
});

/**
 * Loading MatchHeight
 * Create new instance of MatchHeight [new MatchHeight()]
 * for elements that need to have the same height
 * https://www.npmjs.com/package/js-match-height
 */

const testimonialItem = new MatchHeight('.testimonials-section__item');
const whychooseusItem = new MatchHeight('.why-choose-us__item');
function handleContactSidebarMatchHeight() {
    const selector = '.contact-sidebar .sidebar-item';
    if (window.innerWidth >= 992) {
        new MatchHeight(selector);
    }
   
}

// Initial call on page load
handleContactSidebarMatchHeight();

// Re-apply on window resize
window.addEventListener('resize', handleContactSidebarMatchHeight);

/**
 * Smooth Scroll
 * add class '.scroll' to new elements
 * class '.scroll' already added to footer back to top and TOC dynamic link elements
 */
// smooth scroll
document.addEventListener(
    'click',
    (event) => {
        if (!event.target.closest('.scroll')) return;

        const hashValue = event.target.closest('.scroll').getAttribute('href');
        const target = document.querySelector(hashValue);

        target.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });
        history.pushState(null, null, hashValue);
        event.preventDefault();
    },
    false
);

/**
 * Moving results – horizontal scroll on page load
 */
document.addEventListener('DOMContentLoaded', () => {
    const movingResults = document.querySelector('.moving-results');
    if (movingResults) {
        const results = movingResults.querySelectorAll('.result');
        if (results.length) {
            const track = document.createElement('div');
            track.className = 'moving-results__track';
            results.forEach((el) => track.appendChild(el.cloneNode(true)));
            results.forEach((el) => track.appendChild(el.cloneNode(true)));
            movingResults.innerHTML = '';
            movingResults.appendChild(track);
        }
    }
});

/**
 * Load More
 */
const loadMore = null || document.querySelector('.load-more');
const categoryFilter = null || document.querySelector('.cw-filter');

if (loadMore || categoryFilter) {
    const enablePagination = loadMore.dataset.pagination;

    CwLoadModules.AjaxCalls().then((cwAjaxLib) => {
        const ajaxCalls = new cwAjaxLib({
            enablePagination: enablePagination,
        });
        ajaxCalls.init();
        if (categoryFilter) ajaxCalls.filter(categoryFilter);
    });
}

// Fix for nav tab clicks on resource-page.php

document.addEventListener('DOMContentLoaded', function () {
    // Only run this on the resource-page template
    if (document.body.classList.contains('page-template-resource-page')) {
        const catItems = document.querySelectorAll('.resources-cat-list li');
        if (catItems.length) {
            catItems.forEach(function (catItem) {
                catItem.addEventListener('click', function (e) {
                    // Only target anchor clicks within list items, but not if any .faqTab .nav-link
                    const link = e.target.closest('a');
                    if (!link) return;
                    console.log('resources-cat-list item clicked:', link);


                    // Adapted from cw-video.js:
                    var check_for_lightbox_links = function(type) {
                        console.log('check_for_lightbox_links called with type:', type);
                        jQuery(".cw_video_open_popup, .cw_video_open_popup_customized").each(function() {
                            var $el = jQuery(this);
                            var videoType = type ? type : $el.attr("video_type");
                            var videoId = $el.attr("video_id");
                            var videoHeight = $el.attr("video_height") ? $el.attr("video_height") : 400;
                            var videoWidth = $el.attr("video_width") ? $el.attr("video_width") : 600;
                            var videoShowInfo = $el.attr("video_showinfo");
                            var videoRel = $el.attr("video_rel");
                            var videoAutoplay = $el.attr("video_autoplay") ? $el.attr("video_autoplay") : 1;
                            var winWidth = jQuery(window).width();
                            var heightFinal = videoHeight;
                            var widthFinal = videoWidth;

                            if (winWidth <= 700 || winWidth <= videoWidth) {
                                var scaleW = 0.85;
                                widthFinal = Math.round(scaleW * winWidth);
                                var scaleH = 0.565;
                                heightFinal = Math.round(widthFinal * scaleH);
                            }

                            switch (videoType) {
                                case "youtube":
                                    $el.attr(
                                        "href",
                                        "https://www.youtube.com/embed/" + videoId +
                                        "?rel=" + videoRel +
                                        "&showinfo=" + videoShowInfo +
                                        "&autoplay=" + videoAutoplay +
                                        "&mute=1"
                                    );
                                    $el.colorbox({iframe:true, innerWidth:widthFinal, innerHeight:heightFinal});
                                    break;
                                case "vimeo":
                                    $el.attr(
                                        "href",
                                        "https://player.vimeo.com/video/" + videoId +
                                        "?title=" + videoShowInfo +
                                        "&byline=" + videoShowInfo +
                                        "&autoplay=" + videoAutoplay +
                                        "&portrait=0&color=333"
                                    );
                                    $el.colorbox({iframe:true, innerWidth:widthFinal, innerHeight:heightFinal});
                                    break;
                                default:
                                    $el.attr(
                                        "href",
                                        "https://fast.wistia.net/embed/iframe/" + videoId
                                    );
                                    $el.colorbox({iframe:true, innerWidth:widthFinal, innerHeight:heightFinal});
                                    break;
                            }
                        });
                    };
                    setTimeout(function() {
                        check_for_lightbox_links();
                    }, 1000);
                });
            });
        }
    }
});


